import {
  MENU_HOME,
  MENU_CRM,
  MENU_CUSTOMER_LIST,
  MENU_POTENTIAL_CUSTOMERS,
  MENU_BUSSINESS,
  MENU_ORDER,
  MENU_SHOP,
  MENU_DYNAMIC,
  MENU_APPRAISE,
  MENU_CONTENT,
  MENU_EXPERIENCE_SHOP,
  MENU_CUSTOMER_RECOMMEND,
  MENU_SETTING,
  MENU_ACCOUNT,
  MENU_JIAMENG_SHOP,
  MENU_JIAMENG_GOODS,
  // MENU_JIAMENG_CUSTOMER,
  MENU_JIAMENG_NEW_CUSTOMER,
  MENU_JIAMENG_ORDER,
  MENU_JIAMENG_MARKETING,
  MENU_JIAMENG_SCHEDULE,
  MENU_JIAMENG_STATS,
  MENU_JIAMENG_SETTING,
  MENU_INCOME,
  MENU_DECORATION,
  MENU_INFO,
  MENU_MEAL,
  MENU_EXAMPLE,
  MENU_MARKETING,
  MENU_MARKETCENTER,
  MENU_ACTIVITYREGISTER,
  MENU_LIVE_MANAGE,
  MENU_MEMBER_MANAGE,
  MENU_MEMBER_MANAGE_MEMBER,
  MENU_LITE_APP,
  MENU_REALNAME_AUTH,
  MENU_SCHEDULE_TOOL,
  MENU_MEMBER_MANAGE_SETTING,
  MENU_CREATIVE_CENTER,
  MENU_EXPERIENCE_SHOP_COOP,
  MENU_BOND,
  MENU_SELLERSERVICE_AUTH,
  MENU_SETTLEMENTACCOUNT_AUTH,
  MENU_JIAMENG_COOPERATION,
  MENU_POPULARIZATION_CENTER,
  MENU_ZHITUIBAO
} from './menu'
import {
  PRODUCT_MICRO_WEBSITE,
  PRODUCT_THEME_TEMPLATE,
  PRODUCT_RECOMMEND_WINDOW,
  PRODUCT_CONSULT_GIFT,
  PRODUCT_MEAL_HOT_TAG,
  PRODUCT_ARRIVE_GIFT
  // PRODUCT_WEDDING_HALL,
  // PRODUCT_EASY_CHAT,
  // PRODUCT_SKY_EYE
} from '../merchant/product'

export const PRIVILEGE_NORMAL_ID = 1 // 普通店铺账号
export const PRIVILEGE_STORE_ID = 2 // 门店（加盟店）账号
export const PRIVILEGE_NORMAL_SERVICE_ID = 3 // 普通店铺员工／客服账号
export const PRIVILEGE_STORE_SERVICE_ID = 4 // 门店（加盟店）员工/客服账号
export const PRIVILEGE_GROUP_ID = 5 // 团队账号（shop_type为5，包含三大团队、司仪团队）

export const ROLE_ADMIN = 1 // 管理员角色
export const ROLE_SERVICE = 4 //客服角色
export const OLD_LITEAPP = 1 // 小程序老用户

/**
 * 管理员权限
 */
export const NORMAL_PRIVILEGE = {}

/**
 * 非管理员（员工/客服）权限
 */
export const NORMAL_SERVICE_PRIVILEGE = {
  menu: [
    MENU_HOME,
    MENU_CRM,
    MENU_CUSTOMER_LIST,
    MENU_POTENTIAL_CUSTOMERS,
    MENU_BUSSINESS,
    MENU_ORDER,
    MENU_SHOP,
    MENU_CONTENT,
    MENU_DYNAMIC,
    MENU_APPRAISE,
    MENU_EXPERIENCE_SHOP,
    MENU_CUSTOMER_RECOMMEND,
    MENU_SETTING,
    MENU_ACCOUNT,
    MENU_SELLERSERVICE_AUTH
  ]
}

/**
 * 加盟店管理员权限
 */
export const STORE_PRIVILEGE = {
  menu: [
    MENU_HOME,
    MENU_JIAMENG_SHOP,
    MENU_JIAMENG_GOODS,
    MENU_JIAMENG_COOPERATION,
    // MENU_JIAMENG_CUSTOMER,
    MENU_JIAMENG_NEW_CUSTOMER,
    MENU_JIAMENG_ORDER,
    MENU_JIAMENG_MARKETING,
    MENU_JIAMENG_SCHEDULE,
    MENU_JIAMENG_STATS,
    MENU_JIAMENG_SETTING
  ],
  storeExtends: [
    PRODUCT_MICRO_WEBSITE,
    PRODUCT_THEME_TEMPLATE,
    PRODUCT_RECOMMEND_WINDOW
  ],
  qualityService: [
    PRODUCT_CONSULT_GIFT,
    PRODUCT_MEAL_HOT_TAG,
    PRODUCT_ARRIVE_GIFT
  ]
}

/**
 * 加盟店非管理员（员工/客服）权限
 */
export const STORE_SERVICE_PRIVILEGE = {
  menu: [
    MENU_HOME,
    // MENU_JIAMENG_CUSTOMER,
    MENU_JIAMENG_NEW_CUSTOMER,
    MENU_JIAMENG_ORDER,
    MENU_JIAMENG_SCHEDULE,
    MENU_JIAMENG_SETTING
  ]
}

/**
 * 四大团队权限
 */
export const GROUP_PRIVILEGE = {
  menu: [
    MENU_HOME,
    MENU_SCHEDULE_TOOL,
    MENU_CRM,
    MENU_CUSTOMER_LIST,
    MENU_BUSSINESS,
    MENU_ORDER,
    MENU_INCOME,
    MENU_EXPERIENCE_SHOP_COOP,
    MENU_SHOP,
    MENU_DECORATION,
    MENU_APPRAISE,
    MENU_INFO,
    MENU_CONTENT,
    MENU_MEAL,
    MENU_EXAMPLE,
    MENU_DYNAMIC,
    MENU_CREATIVE_CENTER,
    MENU_MARKETING,
    MENU_MARKETCENTER,
    MENU_ACTIVITYREGISTER,
    MENU_LIVE_MANAGE,
    MENU_ZHITUIBAO,
    MENU_MEMBER_MANAGE,
    MENU_MEMBER_MANAGE_MEMBER,
    MENU_MEMBER_MANAGE_SETTING,
    MENU_EXPERIENCE_SHOP,
    MENU_POPULARIZATION_CENTER,
    MENU_LITE_APP,
    MENU_SETTING,
    MENU_ACCOUNT,
    MENU_REALNAME_AUTH,
    MENU_BOND,
    MENU_SELLERSERVICE_AUTH,
    MENU_SETTLEMENTACCOUNT_AUTH
  ]
}
